import DownloadListBlock from "./DownloadlistBlock.vue";

bootVue(".vue-download-list", DownloadListBlock, {
  jsonProps: ["items", "fields"],
  beforeMount: (el, props) => {
    if (Array.isArray(props.items)) {
      props.items = props.items.map(it => {
        if (it && typeof it === "object") {
          if (typeof it.fileExtension !== "string") it.fileExtension = "";
          if (!it.downloadLink) it.downloadLink = { link: "#", linkTarget: "_self", gated: false };
          if (typeof it.fileSize !== "number") it.fileSize = 0;
        }
        return it;
      });
    }
  }
});